export enum WebServiceMethod {
  Get = 0,
  Post = 1,
  Patch = 2,
  Put = 3,
  Delete = 4,
  Image = 5
}
